import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import './styles/features/beginner-flow.css';
import App from './App';
import { loadLiquidityRule } from './utils/liquidityRule';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  process.env.NODE_ENV === 'development' ? (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ) : (
    <App />
  )
);

// The liquidity rule (filters, chips) comes from the backend so it always matches
// the score's cap. Fetched in the background: pages render with today's rule and
// switch when the server rule arrives (utils/liquidityRule.ts). Never blocks.
void loadLiquidityRule();
